import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import { useScrollReset } from "@/lib/useScrollReset";
import { Admin } from "@/routes/Admin";
import { Home } from "@/routes/Home";
import { NotFound } from "@/routes/NotFound";
import { Player } from "@/routes/Player";
import { Profile } from "@/routes/Profile";
import { Projects } from "@/routes/Projects";
import { Puzzles } from "@/routes/Puzzles";

/**
 * The board is the one heavy thing on the site — a whole Tetris engine — and
 * since it stopped being embedded anywhere it is reachable from exactly one
 * route. Loading it on demand keeps it out of the bundle every other page
 * pays for, including the home page.
 */
const Play = lazy(() => import("@/routes/Play").then((m) => ({ default: m.Play })));

export default function App() {
  useScrollReset();

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route
        path="/play"
        element={
          <Suspense fallback={<p className="shell meta py-10 opacity-60">Loading the board…</p>}>
            <Play />
          </Suspense>
        }
      />
      <Route path="/projects" element={<Projects />} />
      <Route path="/puzzles" element={<Puzzles />} />
      <Route path="/players/:username" element={<Player />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
